/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';


/**
* @augments {Component<{  className:string,  text:string,  style :any>}
*/
class HTMLText extends Component {

	constructor(props) {
		super(props);
		
		this.state = {
			text : this.props.text,
			className : this.props.className
		};
		
	}
	
	componentDidMount() {		
	}
	
	componentWillUnmount() {
	}

	componentWillReceiveProps(nextProps) {
		this.setState({text:nextProps.text, className:nextProps.className});
	} 
	
	
	

	render() {
		return (
			<React.Fragment>
				<span style={this.props.style} className={this.state.className} dangerouslySetInnerHTML={{ __html:this.state.text}}></span>
			</React.Fragment>			
		);
	}
}

HTMLText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  style : PropTypes.any
}

export default HTMLText;